module.exports = "<div class=\"wrapper\">\r\n    <div [id]=\"element\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/texteditor/texteditor.component.html
// module id = ./src/app/components/tools/texteditor/texteditor.component.html
// module chunks = main